<script>
  import { router } from '@inertiajs/svelte'
  
  let { alert = null, user = {} } = $props();
  
  let code = $state('');
  
  function submit(event) {
    event.preventDefault();
    router.post('/two_factor_authentication/challenge/totp', {
      code
    });
  }
</script>

<div class="tfa-challenge-container">
  {#if alert}
    <p class="alert">{alert}</p>
  {/if}

  <form onsubmit={submit}>
    <div class="form-group">
      <label for="code" class="form-label">
        <h1>Next, open the 2FA authenticator app on your phone and type the six digit code below:</h1>
      </label>
      <!-- svelte-ignore a11y_autofocus -->
      <input 
        id="code" 
        type="text" 
        bind:value={code} 
        required 
        autofocus 
        autocomplete="off"
        class="form-input" 
      />
    </div>
    
    <div class="form-actions">
      <button type="submit" class="verify-button">Verify</button>
    </div>
  </form>
  
  <div class="fallback-options">
    <p><strong>Don't have your phone?</strong></p>
    <div class="fallback-link">
      <a href="/two_factor_authentication/challenge/recovery_codes/new">Use a recovery code to access your account.</a>
    </div>
    
    {#if user.has_security_keys}
      <div class="fallback-link">
        <a href="/two_factor_authentication/challenge/security_keys/new">Use a security key to access your account.</a>
      </div>
    {/if}
  </div>
</div>

<style>
  .tfa-challenge-container {
    max-width: 600px;
    margin: 0 auto;
    padding: 2rem 1rem;
  }
  
  h1 {
    font-size: 1.5rem;
    font-weight: 600;
    margin-bottom: 1rem;
  }
  
  .alert {
    color: #b91c1c;
    margin-bottom: 1rem;
    padding: 0.5rem;
    background-color: #fee2e2;
    border-radius: 0.375rem;
  }
  
  .form-group {
    margin-bottom: 1.5rem;
  }
  
  .form-label {
    display: block;
    font-weight: 500;
    margin-bottom: 0.5rem;
  }
  
  .form-input {
    width: 100%;
    max-width: 300px;
    padding: 0.625rem;
    border: 1px solid #d1d5db;
    border-radius: 0.375rem;
    font-size: 1.25rem;
    letter-spacing: 0.25em;
    text-align: center;
  }
  
  .form-actions {
    margin-top: 1.5rem;
  }
  
  .verify-button {
    background-color: #047857;
    color: white;
    border: none;
    padding: 0.625rem 1.25rem;
    border-radius: 0.375rem;
    font-weight: 500;
    font-size: 1rem;
    cursor: pointer;
  }
  
  .verify-button:hover {
    background-color: #065f46;
  }
  
  .fallback-options {
    margin-top: 2rem;
    padding-top: 1.5rem;
    border-top: 1px solid #e5e7eb;
  }
  
  .fallback-link {
    margin-top: 0.5rem;
  }
  
  .fallback-link a {
    color: #047857;
    text-decoration: none;
  }
  
  .fallback-link a:hover {
    text-decoration: underline;
  }
</style>